angular.module('shiftTraderApp')
  .controller('NotesLearningCtrl', function ($scope) {
    $scope.collapse = {
      whatIsIt: false,
      whatCanIDo: true,
      findingNotes: true,
      privacy: true,
      attachments: true
    };

    $scope.toggleCollapse = function(id) {
      $scope.collapse[id] = !$scope.collapse[id];
    };
  });
